import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Support from './views/Support.vue'
import SeriesS from './views/SeriesS.vue'
import Contact from './views/Contact.vue'
// 导入 i18n 实例（假设你已配置 vue-i18n）
import i18n from './lang/index'  // 路径根据你的实际配置调整

Vue.use(Router)

// 创建路由实例
const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {path: '/', redirect: '/zh'}, // 默认重定向到中文
        {
            path: '/zh',
            name: 'home-zh',
            component: Home
        },
        {
            path: '/zh/series-s',
            name: 'series-zh',
            component: SeriesS
        }, {
            path: '/zh/support',
            name: 'support-zh',
            component: Support
        }, {
            path: '/zh/contact',
            name: 'contact-zh',
            component: Contact
        },
        // en path
        {
            path: '/en',
            name: 'home-en',
            component: Home,
        },
        {
            path: '/en/series-s',
            name: 'series-en',
            component: SeriesS
        },
        {
            path: '/en/contact',
            name: 'contact-en',
            component: Contact
        },
        {
            path: '/en/support',
            name: 'support-en',
            component: Support
        },
    ],
})

router.beforeEach((to, from, next) => {
    const lang = to.path.split('/')[1]
    if (['zh', 'en'].includes(lang)) {
        i18n.locale = lang
    } else {
        // 默认 zh
        i18n.locale = 'zh'
    }
    next()
})

export default router
